<div class="background-view">

    <div class="container bg-light position-relative">
        <app-header></app-header>
        <router-outlet></router-outlet>
        <app-footer></app-footer>
    </div>
</div>
<style>
    .background-view {
        background: url("../../../assets/img/background.jpg");
        min-height: 100%;
        background-repeat: no-repeat;
        background-position: center center;
        object-fit: contain;
        background-attachment: fixed;
        transition: scale();
    }

    .container {
        min-height: 100vh;
        background-color: white;
    }
</style>